import styled from 'styled-components';
import { rhythm } from '../../utils/typography';
import { media } from '../../utils/styles';

export const Topic = styled.h2<{ opacity?: number; degree?: number }>`
  opacity: ${({ opacity = 1 }) => opacity};
  margin: ${rhythm(5 / 3)} 0;
  margin-left: ${({ degree = 0 }) => rhythm(degree > 1 ? degree - 1 : 0)};
  cursor: pointer;
  ${media.mobile`margin-left: 0;`}
`;
